import { generateTypes } from '../../utils/HttpReducerHelper';

const moveTeamMembers = generateTypes('TEAM_WIZZARD', 'MOVE_TEAM_MEMBERS');

export { moveTeamMembers };
